import { get } from "lodash-es";

const ENDY_ORG_IDS = [
  "b3db63e4-d3eb-11e9-9873-cbd4e05ea08f", // demo
  "ee31c32c-0fc2-11ea-bc79-47205e425e53", // staging
  "b7c3f070-f882-11ec-84d3-4b616ead2166", // staging 3
  "896584ca-0f35-11ea-95b2-e7cdcc9932f6", // production
];

const ENDY_FULFILLMENT_ORG_IDS = [
  "9eef8d92-0779-11ed-bccd-a373843a6369", // staging 4
  "a71cd80e-9c9e-11eb-9826-97cd8385fffc", // preprod
  "ceecbef2-8674-11eb-b476-33f63a9f3e35", // production
];

const IKEA_ORG_IDS = {
  staging: [
    "1cc0c40a-43a2-11ea-94b5-df8fd7904ab8", // IKEA canada
    "20fa4746-1cdd-11ed-bf7c-bb6eddd7f817", // IKEA US
    "473ef1d0-2f9e-11ed-ad4a-9b0587508af9", // IKEA Trunkline
  ],
  production: [
    "4eb2d36c-4e70-11ea-8ee7-f39aa09266cc", // IKEA canada
    "132d7592-1cde-11ed-9433-5b810b151745", // IKEA US
    "970d26ee-2fa0-11ed-b12b-67f2d6bc79db", // IKEA Trunkline
  ],
};

const HAMUQ_ORG_IDS = [
  "49f2b92e-a0ea-11ea-9def-cb356a000d64", // production
  "99612bd8-a11e-11ea-a6dc-eb9a42afb5f8", // staging
];

const SAMARA_ORG_IDS = [
  "300bec90-0e29-11eb-96ce-a7597249f34f", // staging2
  "954b4962-fe79-11ea-8961-abc8b231e3da", // production
];

const BETTER_BOVINE_IDS = [
  "8e2e767c-e454-11ed-aa64-47caff7472bb", // staging
  "b4ee9fce-1177-11f0-a10c-2f81b7b8feda", // production
];

const GOODR_IDS = [
  "f1cb37f2-6331-11f0-ac20-1b277747f9e3", // production
];

const FIERA_IDS = [
  "4829e768-8ff8-11f0-9602-433b47edfe8e", // production
];
export default class Organization {
  static isSamara = (organization) => {
    const orgID = get(organization, "id");
    return SAMARA_ORG_IDS.includes(orgID);
  };

  static isSamaraId = (organizationId) => {
    return SAMARA_ORG_IDS.includes(organizationId);
  };

  static isEndy = (organization) => {
    const orgID = get(organization, "id");
    return ENDY_ORG_IDS.includes(orgID);
  };

  static isEndyFulfillment = (organization) => {
    const orgID = get(organization, "id");
    return ENDY_FULFILLMENT_ORG_IDS.includes(orgID);
  };

  static isIKEA = (organization) => {
    const organizationID = get(organization, "id");
    return Organization.isIkeaOrgID(organizationID);
  };

  static isGoBolt = (name = "") => {
    return ["second closet", "bolt logistics", "jarvis"].includes(name.toLowerCase());
  };

  static isSecondCloset = (organization) => {
    return this.isGoBolt(organization?.name);
  };

  static isIkeaOrgID = (organizationID) => {
    return Object.values(IKEA_ORG_IDS).flat().includes(organizationID);
  };

  static isBetterBovine = (orgId) => {
    return BETTER_BOVINE_IDS.includes(orgId);
  };

  static isGoodr = (orgId) => {
    return GOODR_IDS.includes(orgId);
  };

  static getIkeaOrgIDs = () => {
    const isProduction = process.env.REACT_APP_ENV === "production";
    if (isProduction) {
      return IKEA_ORG_IDS.production;
    }
    return IKEA_ORG_IDS.staging;
  };

  static isHamuq = (organization) => {
    const organizationID = get(organization, "id");
    return HAMUQ_ORG_IDS.includes(organizationID);
  };

  static isVessi = (organization) => {
    return organization?.name?.toLowerCase().includes("vessi");
    // TODO: drop string check once we have org IDs
    // const organizationID = get(organization, "id");
    // return VESSI_ORG_IDS.includes(organizationID);
  };

  static getDefaultFulfilledFromFacility = (organization) => {
    const configurations = get(organization, "configurations");
    const fulfilledFromObj = configurations.find((config) => config.key === "default_fulfilled_from");
    return fulfilledFromObj ? fulfilledFromObj.value : "yyz3";
  };

  static getPreferredReturnFacility = (organization) => {
    const configurations = organization?.configurations_attributes || [];
    return configurations.find((config) => config.key === "preferred_return_facility")?.value;
  };

  static getMaxFulfillableQuantity = (organizationId) => {
    if ([...GOODR_IDS, ...FIERA_IDS].includes(organizationId)) {
      return 10000;
    } else if ([...BETTER_BOVINE_IDS].includes(organizationId)) {
      return 5000;
    }
    return 1200;
  };
}

export const orgStatusColor = {
  active: "blue",
  paused: "orange",
  churned: "red",
};
